import { render, staticRenderFns } from "./loadPipeDetail.vue?vue&type=template&id=0801815b&"
import script from "./loadPipeDetail.vue?vue&type=script&lang=js&"
export * from "./loadPipeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports